module.exports = __webpack_public_path__ + "static/media/transcripts.53de261b.pdf";